export const LoginIllustration: React.FC = () => {
  return (
    <svg
      width="405"
      height="444"
      viewBox="0 0 405 444"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="10.9775"
        y="172.642"
        width="184.848"
        height="308.079"
        rx="5.36957"
        transform="rotate(-30 10.9775 172.642)"
        fill="#ECE6FE"
      />
      <path
        d="M13.6623 177.292C12.1796 174.724 13.0595 171.44 15.6277 169.957L166.178 83.0369C168.746 81.5541 172.03 82.434 173.512 85.0023L180.56 97.209L20.7099 189.499L13.6623 177.292Z"
        fill="#CCC3FC"
      />
      <g filter="url(#filter0_f)">
        <path
          d="M251.99 361.592C251.372 360.523 250.393 360.48 249.171 360.876L248.765 361.011L247.39 358.63C248.288 358.187 248.984 358.405 249.354 358.96L250.005 358.584C249.452 357.626 248.321 357.386 247.052 358.044L246.612 357.282L246.268 357.48L246.703 358.234C245.451 359.031 245.17 360.111 245.734 361.087C246.26 361.999 247.168 362.219 248.409 361.812L248.711 361.712L250.22 364.326C249.172 364.831 248.402 364.507 247.948 363.827L247.297 364.203C247.914 365.272 249.101 365.653 250.558 364.911L250.993 365.665L251.337 365.466L250.907 364.722C252.244 363.901 252.656 362.746 251.99 361.592ZM248.274 361.171C247.326 361.483 246.74 361.263 246.413 360.695C246.08 360.119 246.162 359.402 247.041 358.82L248.378 361.136L248.274 361.171ZM250.569 364.136L249.098 361.588L249.315 361.512C250.15 361.241 250.876 361.231 251.322 362.003C251.74 362.728 251.543 363.524 250.569 364.136ZM257.019 361.07L257.679 360.688L256.664 358.931L257.408 358.501L257.097 357.962L256.353 358.391L253.921 354.178L253.26 354.559L252.642 360.534L252.954 361.073L256.004 359.312L257.019 361.07ZM253.256 360.179L253.749 355.406L255.693 358.772L253.256 360.179ZM259.451 350.985L260.89 353.478C260.188 353.077 259.332 353.162 258.615 353.576C257.49 354.225 256.876 355.609 257.88 357.349C258.878 359.078 260.39 359.248 261.515 358.598C262.231 358.184 262.733 357.485 262.737 356.677L263.21 357.495L263.87 357.114L260.111 350.604L259.451 350.985ZM261.304 357.975C260.449 358.469 259.28 358.313 258.512 356.983C257.744 355.653 258.194 354.563 259.049 354.069C259.896 353.581 261.083 353.726 261.851 355.056C262.619 356.386 262.151 357.487 261.304 357.975ZM266.899 355.489C267.876 354.925 268.619 354 268.007 352.94C267.534 352.122 266.81 352.155 265.897 352.422L264.877 352.738C264.177 352.944 263.785 352.823 263.57 352.451C263.28 351.949 263.556 351.417 264.273 351.004C264.933 350.623 265.536 350.572 266.038 351.163L266.596 350.84C265.978 349.92 264.986 349.898 263.963 350.488C262.902 351.101 262.46 351.988 262.949 352.835C263.325 353.486 263.979 353.653 264.944 353.369L265.979 353.057C266.608 352.88 267.053 352.834 267.343 353.336C267.713 353.978 267.278 354.576 266.608 354.963C265.966 355.333 265.181 355.477 264.696 354.852L264.091 355.201C264.716 356.154 265.83 356.107 266.899 355.489ZM268.815 347.687C267.624 348.374 267.17 349.219 267.728 350.187L267.814 350.336L268.447 349.97L268.388 349.868C268.017 349.226 268.255 348.692 269.082 348.215C269.891 347.747 270.504 347.778 270.993 348.624L271.143 348.885C271.224 349.024 271.06 349.255 270.591 349.625L269.611 350.377C268.628 351.143 268.301 351.865 268.768 352.674C269.278 353.558 270.171 353.601 271.101 353.064C272.291 352.376 272.439 351.386 272.414 351.065L272.442 351.049L272.926 351.886L273.549 351.526L271.653 348.243C270.982 347.081 270.08 346.957 268.815 347.687ZM271.911 350.215C272.126 350.587 272.106 351.776 270.915 352.464C270.33 352.802 269.745 352.842 269.407 352.256C269.16 351.828 269.23 351.391 270.025 350.771L270.921 350.067C271.326 349.759 271.495 349.537 271.449 349.415L271.911 350.215ZM276.944 349.69C278.348 348.879 278.84 347.541 278.175 346.388C277.579 345.355 276.528 345.255 275.737 345.538C276.326 344.925 276.4 344.151 276.008 343.472C275.476 342.551 274.376 342.257 273.111 342.987C271.855 343.712 271.429 344.863 272.229 346.249L272.861 345.884C272.239 344.805 272.625 344.036 273.425 343.574C274.253 343.096 275.002 343.234 275.4 343.922C275.722 344.481 275.735 345.254 274.609 345.904L274.377 346.038L274.677 346.559L274.947 346.403C276.054 345.764 276.995 345.891 277.483 346.737C277.999 347.63 277.56 348.566 276.639 349.097C275.616 349.688 274.644 349.443 274.07 348.472L273.438 348.837C274.183 350.106 275.465 350.544 276.944 349.69ZM280.157 347.711L284.389 345.268L284.061 344.7L280.573 346.714L280.536 346.649C280.079 345.858 280.397 344.968 281.06 343.755C281.698 342.605 282.216 341.612 281.582 340.514C280.975 339.463 279.773 339.141 278.498 339.877C277.187 340.634 276.897 341.892 277.568 343.055L277.665 343.222L278.316 342.846L278.241 342.716C277.688 341.758 278.007 340.916 278.826 340.444C279.644 339.971 280.482 340.133 280.938 340.923C281.432 341.779 280.956 342.587 280.329 343.755C279.466 345.332 279.352 346.316 280.012 347.46L280.157 347.711ZM288.397 342.953L289.058 342.572L288.043 340.814L288.787 340.385L288.476 339.845L287.732 340.275L285.299 336.062L284.639 336.443L284.021 342.417L284.332 342.957L287.383 341.195L288.397 342.953ZM284.635 342.063L285.127 337.289L287.071 340.656L284.635 342.063ZM289.168 333.729C287.894 334.464 287.454 335.871 288.26 337.266C289.049 338.634 290.409 338.927 291.609 338.235C292.399 337.778 292.889 337.037 292.826 336.155C293.628 337.565 294.057 339.103 292.671 339.903C291.825 340.392 291.07 340.158 290.676 339.604L290.09 339.942C290.57 340.731 291.671 341.199 292.973 340.448C294.843 339.368 294.352 337.358 293.364 335.647C292.08 333.424 290.591 332.907 289.168 333.729ZM291.414 337.64C290.447 338.198 289.472 337.906 288.898 336.911C288.318 335.906 288.518 334.836 289.485 334.277C290.443 333.724 291.485 334.09 292.06 335.085C292.634 336.08 292.382 337.082 291.414 337.64ZM298.875 337.028C300.298 336.207 300.712 334.454 299.434 332.241C298.167 330.046 296.437 329.52 295.014 330.341C293.591 331.163 293.173 332.93 294.44 335.124C295.718 337.338 297.452 337.85 298.875 337.028ZM298.547 336.461C297.394 337.127 296.071 336.489 295.072 334.759C294.079 333.039 294.188 331.574 295.342 330.909C296.495 330.243 297.808 330.886 298.802 332.606C299.8 334.336 299.7 335.795 298.547 336.461Z"
          fill="#5352FC"
        />
      </g>
      <rect
        x="0.916871"
        y="170.71"
        width="183.505"
        height="306.737"
        rx="4.69838"
        transform="rotate(-30 0.916871 170.71)"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M40.9707 196.401L176.407 118.207"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M156.417 396.359L291.853 318.165"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M166.807 413.153L169.03 411.87C171.076 410.689 171.432 408.921 170.229 406.838C169.026 404.754 167.317 404.179 165.271 405.36L163.048 406.643L166.807 413.153ZM167.286 411.749L164.504 406.931L165.667 406.26C167.211 405.369 168.293 405.761 169.243 407.407C170.188 409.044 169.992 410.186 168.448 411.077L167.286 411.749ZM176.026 404.507C175.049 402.815 173.662 402.624 172.415 403.343C171.169 404.063 170.544 405.428 171.569 407.205C172.579 408.953 174.061 409.114 175.372 408.357C176.358 407.788 176.919 406.869 176.589 405.633L175.752 406.116C175.875 406.802 175.571 407.263 174.976 407.606C174.083 408.122 173.288 407.948 172.622 406.944L176.202 404.877C176.162 404.764 176.123 404.675 176.026 404.507ZM172.235 406.275C171.791 405.291 172.049 404.534 172.83 404.083C173.667 403.6 174.438 403.862 174.951 404.707L172.235 406.275ZM178.171 400.02C177.455 400.434 177.029 401.113 177.047 401.81L176.606 401.047L175.667 401.59L179.48 408.193L180.419 407.651L178.958 405.121C179.553 405.485 180.354 405.456 181.071 405.042C182.149 404.419 182.788 403.034 181.779 401.285C180.764 399.528 179.25 399.397 178.171 400.02ZM180.419 404.365C179.675 404.794 178.638 404.674 177.956 403.492C177.274 402.311 177.688 401.353 178.432 400.923C179.185 400.488 180.204 400.62 180.886 401.801C181.568 402.982 181.172 403.93 180.419 404.365ZM186.387 401.973C187.596 401.275 188.298 399.828 187.3 398.098C186.301 396.368 184.696 396.253 183.487 396.951C182.288 397.643 181.585 399.09 182.584 400.82C183.583 402.55 185.187 402.666 186.387 401.973ZM185.931 401.182C185.149 401.633 184.164 401.495 183.477 400.305C182.79 399.114 183.163 398.192 183.944 397.741C184.725 397.29 185.719 397.423 186.407 398.613C187.094 399.804 186.712 400.731 185.931 401.182ZM191.487 399.029C192.547 398.416 193.278 397.449 192.66 396.379C192.183 395.552 191.414 395.574 190.525 395.839L189.496 396.16C188.939 396.333 188.592 396.248 188.404 395.923C188.168 395.513 188.405 395.066 189.01 394.717C189.587 394.384 190.105 394.358 190.541 394.899L191.332 394.443C190.711 393.475 189.703 393.362 188.578 394.012C187.462 394.656 187.002 395.579 187.512 396.462C187.888 397.113 188.557 397.347 189.592 397.035L190.612 396.719C191.132 396.567 191.488 396.56 191.713 396.951C192.014 397.472 191.678 397.963 191.083 398.307C190.487 398.651 189.847 398.723 189.429 398.171L188.583 398.659C189.212 399.685 190.324 399.7 191.487 399.029ZM191.602 391.274C191.899 391.102 192.02 390.71 191.843 390.403C191.666 390.096 191.266 390.005 190.968 390.177C190.67 390.348 190.55 390.741 190.727 391.047C190.904 391.354 191.304 391.446 191.602 391.274ZM194.412 397.216L195.351 396.673L192.559 391.837L191.62 392.379L194.412 397.216ZM198.24 394.076C197.756 394.355 197.456 394.243 197.182 393.769L195.614 391.053L196.572 390.5L196.148 389.765L195.19 390.318L194.487 389.1L193.547 389.642L194.251 390.86L193.46 391.317L193.884 392.052L194.675 391.595L196.334 394.469C196.882 395.418 197.648 395.434 198.438 394.978C198.643 394.86 198.838 394.747 199.027 394.601L198.603 393.866L198.24 394.076Z"
        fill="#5352FC"
      />
      <rect
        x="49.0249"
        y="210.352"
        width="102.022"
        height="13.4239"
        rx="2.68479"
        transform="rotate(-30 49.0249 210.352)"
        fill="#CCC3FC"
      />
      <rect
        x="63.4556"
        y="235.347"
        width="79.8724"
        height="13.4239"
        rx="2.68479"
        transform="rotate(-30 63.4556 235.347)"
        fill="#CCC3FC"
      />
      <path
        d="M75.7105 239.122C77.809 236.748 76.7353 233.105 80.7334 230.797C85.0699 228.293 87.7671 231.773 91.1541 229.818C95.4905 227.314 94.6101 222.785 98.5129 220.532C102.849 218.028 105.898 221.306 109.367 219.303C112.836 217.3 113.691 211.769 117.593 209.516C121.496 207.262 124.545 210.54 130.182 207.285"
        stroke="#5352FC"
        strokeWidth="1.34239"
        strokeLinecap="round"
      />
      <path
        d="M164.247 22.1612C163.55 21.8957 163.55 20.6696 164.246 20.4016C167.219 19.2574 172.116 17.0648 174.702 14.2186C177.09 11.5902 179.066 5.94485 180.084 2.61249C180.318 1.84758 181.374 1.83419 181.622 2.59345C182.709 5.9233 184.796 11.5852 187.155 14.2186C189.515 16.8526 194.589 19.1821 197.572 20.3955C198.252 20.6721 198.241 21.851 197.556 22.1123C194.561 23.2545 189.468 25.4823 187.029 28.205C184.629 30.8836 182.658 36.4287 181.62 39.7903C181.38 40.5674 180.286 40.5626 180.051 39.7837C179.037 36.4227 177.104 30.8856 174.702 28.205C172.294 25.5175 167.279 23.3163 164.247 22.1612Z"
        fill="#ECE6FE"
      />
      <rect
        x="220.824"
        y="10.0679"
        width="183.908"
        height="308.079"
        rx="9.24238"
        fill="white"
      />
      <rect
        x="220.824"
        y="11.4103"
        width="183.505"
        height="306.737"
        rx="4.69838"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M193.32 76.3128C193.291 76.3008 193.215 76.239 193.214 76.0545C193.214 75.87 193.291 75.8057 193.321 75.7929C195.102 75.0402 197.525 73.8244 198.949 72.257C199.638 71.499 200.246 70.4105 200.758 69.2948C201.275 68.1686 201.715 66.9651 202.055 65.9394C202.068 65.9019 202.12 65.8269 202.262 65.8251C202.404 65.8234 202.456 65.8968 202.469 65.9328C202.829 66.9584 203.291 68.1635 203.822 69.2912C204.348 70.4084 204.964 71.4968 205.642 72.2536C206.32 73.0105 207.296 73.6979 208.297 74.2854C209.308 74.8785 210.388 75.3944 211.307 75.796C211.339 75.81 211.405 75.8679 211.403 76.0271C211.402 76.1864 211.334 76.2446 211.301 76.2584C210.377 76.6408 209.29 77.1377 208.268 77.7228C207.255 78.3028 206.265 78.9923 205.565 79.7734C204.884 80.5339 204.28 81.6011 203.77 82.6984C203.256 83.8048 202.816 84.9859 202.472 86.0069C202.461 86.0401 202.406 86.1237 202.244 86.123C202.083 86.1223 202.028 86.0382 202.017 86.0045C201.68 84.9839 201.247 83.804 200.738 82.6985C200.234 81.602 199.634 80.535 198.952 79.7734C198.267 79.009 197.303 78.3336 196.311 77.763C195.311 77.1876 194.242 76.6961 193.32 76.3128Z"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M126.201 55.5057C126.172 55.4937 126.095 55.4318 126.095 55.2474C126.095 55.0629 126.172 54.9986 126.202 54.9858C127.982 54.233 130.405 53.0172 131.829 51.4499C132.518 50.6919 133.126 49.6033 133.638 48.4877C134.155 47.3615 134.596 46.158 134.936 45.1323C134.948 45.0948 135 45.0197 135.142 45.018C135.285 45.0162 135.337 45.0897 135.349 45.1256C135.709 46.1512 136.171 47.3563 136.702 48.4841C137.229 49.6012 137.844 50.6897 138.522 51.4464C139.201 52.2034 140.176 52.8907 141.177 53.4783C142.188 54.0713 143.268 54.5873 144.187 54.9889C144.219 55.0029 144.285 55.0608 144.284 55.22C144.282 55.3793 144.215 55.4374 144.181 55.4513C143.257 55.8336 142.171 56.3306 141.149 56.9156C140.135 57.4957 139.145 58.1852 138.445 58.9663C137.764 59.7268 137.161 60.794 136.651 61.8913C136.136 62.9976 135.696 64.1787 135.352 65.1998C135.341 65.233 135.286 65.3165 135.125 65.3159C134.963 65.3152 134.908 65.2311 134.897 65.1973C134.56 64.1768 134.127 62.9969 133.619 61.8913C133.114 60.7949 132.515 59.7278 131.832 58.9663C131.148 58.2019 130.183 57.5265 129.191 56.9559C128.191 56.3805 127.123 55.889 126.201 55.5057Z"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M158.411 21.4921C158.385 21.4823 158.368 21.4672 158.352 21.4389C158.333 21.4049 158.317 21.35 158.317 21.2823C158.317 21.2147 158.333 21.1593 158.352 21.1247C158.369 21.0956 158.386 21.08 158.412 21.07C159.913 20.4924 161.907 19.6475 163.857 18.5835C165.798 17.5245 167.741 16.2249 169.106 14.722C170.381 13.3185 171.511 11.1581 172.438 8.98343C173.373 6.79312 174.13 4.52068 174.643 2.84054L174.043 2.61249L174.643 2.84054C174.652 2.81037 174.666 2.79172 174.689 2.7755C174.716 2.75595 174.76 2.739 174.814 2.73833C174.868 2.73765 174.912 2.7535 174.939 2.77221C174.962 2.78767 174.976 2.80572 174.986 2.83552C175.534 4.5133 176.336 6.7871 177.302 8.97931C178.262 11.1562 179.411 13.3166 180.667 14.7185C181.923 16.1207 183.859 17.403 185.81 18.4741C187.774 19.5528 189.812 20.4483 191.315 21.0597C191.342 21.0705 191.358 21.0863 191.372 21.1117C191.388 21.1424 191.403 21.1915 191.402 21.2519C191.401 21.3123 191.386 21.3613 191.369 21.392C191.354 21.4175 191.337 21.433 191.31 21.4433C189.8 22.0193 187.753 22.8718 185.771 23.9279C183.801 24.9772 181.838 26.2565 180.54 27.7051C179.263 29.1306 178.133 31.274 177.202 33.4352C176.265 35.6103 175.504 37.8649 174.981 39.56C174.972 39.5892 174.958 39.6082 174.933 39.6254C174.903 39.6461 174.855 39.6638 174.796 39.6635C174.736 39.6633 174.688 39.6451 174.658 39.6241C174.633 39.6067 174.619 39.5874 174.611 39.5581C174.099 37.863 173.353 35.6099 172.428 33.436C171.509 31.2759 170.388 29.1327 169.109 27.7051C167.827 26.2743 165.892 25.0105 163.941 23.9705C161.977 22.9237 159.939 22.0745 158.411 21.4921Z"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M231.331 55.2676C231.301 55.2539 231.213 55.1751 231.212 54.9578C231.212 54.7405 231.3 54.6583 231.332 54.6434C232.459 54.1158 233.793 53.3629 234.651 52.4185C235.482 51.5046 236.161 49.9278 236.628 48.6379C236.642 48.5991 236.707 48.5124 236.874 48.5104C237.041 48.5084 237.105 48.5932 237.119 48.6298C237.61 49.923 238.312 51.5026 239.129 52.415C239.947 53.3279 241.363 54.1116 242.522 54.6598C242.555 54.6753 242.631 54.7468 242.629 54.9332C242.628 55.1198 242.55 55.1922 242.515 55.2079C241.348 55.7359 239.919 56.5044 239.075 57.4469C238.264 58.352 237.598 59.8555 237.13 61.1197C237.117 61.1544 237.047 61.2507 236.857 61.25C236.667 61.2493 236.597 61.1523 236.584 61.117C236.123 59.8544 235.466 58.3531 234.654 57.4469C233.838 56.5359 232.475 55.7906 231.331 55.2676Z"
        fill="#7C71FC"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M235.074 31.0801C235.029 31.0594 234.989 30.9954 234.988 30.8971C234.988 30.7988 235.029 30.7338 235.074 30.7125C235.515 30.5076 236.039 30.2133 236.366 29.8479C236.68 29.4978 236.941 28.8737 237.121 28.3627C237.139 28.3107 237.192 28.2678 237.271 28.2669C237.35 28.2659 237.403 28.3074 237.422 28.3586C237.611 28.8709 237.882 29.4969 238.191 29.847C238.501 30.1974 239.055 30.5039 239.507 30.7176C239.553 30.7389 239.589 30.7997 239.588 30.8886C239.588 30.9777 239.55 31.0383 239.504 31.059C239.048 31.2642 238.49 31.564 238.17 31.9258C237.863 32.2743 237.606 32.872 237.426 33.3743C237.407 33.4259 237.351 33.4709 237.265 33.4705C237.18 33.4702 237.124 33.4247 237.105 33.3729C236.928 32.8712 236.675 32.2745 236.367 31.9258C236.057 31.5753 235.522 31.2838 235.074 31.0801Z"
        fill="#7C71FC"
        stroke="white"
        strokeWidth="0.335598"
      />
      <path
        d="M233.904 24.9029L233.904 24.9038C233.556 25.3978 233.298 25.9932 233.127 26.6864C232.956 27.3621 232.871 28.1124 232.871 28.9361V32.5924C232.871 34.3544 233.208 35.747 233.903 36.7505L233.903 36.7505L233.905 36.7532C234.626 37.7521 235.7 38.2447 237.097 38.2447C238.493 38.2447 239.559 37.7521 240.264 36.7519C240.976 35.7481 241.322 34.3549 241.322 32.5924V28.9361C241.322 28.1125 241.237 27.3622 241.067 26.6864C240.896 25.9931 240.629 25.3974 240.264 24.9033C239.915 24.3916 239.47 23.993 238.929 23.7097C238.4 23.4238 237.787 23.2838 237.097 23.2838C236.39 23.2838 235.768 23.4237 235.238 23.7102C234.714 23.9939 234.269 24.3925 233.904 24.9029ZM231.103 28.7837C231.103 26.5065 231.64 24.7646 232.691 23.5352C233.739 22.3091 235.2 21.6896 237.097 21.6896C238.993 21.6896 240.454 22.3091 241.503 23.5352C242.554 24.7646 243.09 26.5065 243.09 28.7837V32.7447C243.09 35.0915 242.553 36.8483 241.504 38.0423C240.456 39.2352 238.995 39.8388 237.097 39.8388C235.199 39.8388 233.737 39.2352 232.689 38.0423C231.64 36.8483 231.103 35.0915 231.103 32.7447V28.7837Z"
        fill="#7C71FC"
        stroke="white"
        strokeWidth="0.335598"
      />
      <path
        d="M382.675 274.389C382.645 274.375 382.557 274.296 382.557 274.079C382.556 273.862 382.645 273.78 382.677 273.765C383.804 273.237 385.138 272.484 385.996 271.54C386.826 270.626 387.505 269.049 387.973 267.759C387.987 267.72 388.051 267.634 388.218 267.632C388.385 267.63 388.449 267.715 388.463 267.751C388.954 269.044 389.656 270.624 390.473 271.536C391.291 272.449 392.707 273.233 393.866 273.781C393.899 273.797 393.975 273.868 393.974 274.055C393.972 274.241 393.894 274.314 393.859 274.329C392.692 274.857 391.263 275.626 390.419 276.568C389.608 277.473 388.943 278.977 388.474 280.241C388.461 280.276 388.391 280.372 388.201 280.371C388.011 280.371 387.941 280.274 387.928 280.238C387.468 278.976 386.811 277.474 385.999 276.568C385.183 275.657 383.819 274.912 382.675 274.389Z"
        fill="#7C71FC"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M386.033 298.981C385.988 298.96 385.948 298.896 385.947 298.798C385.947 298.699 385.988 298.634 386.033 298.613C386.474 298.408 386.998 298.114 387.325 297.748C387.639 297.398 387.9 296.774 388.08 296.263C388.098 296.211 388.151 296.168 388.23 296.167C388.309 296.166 388.362 296.208 388.381 296.259C388.57 296.771 388.841 297.397 389.15 297.748C389.46 298.098 390.013 298.404 390.466 298.618C390.512 298.639 390.548 298.7 390.547 298.789C390.547 298.878 390.509 298.939 390.463 298.959C390.007 299.165 389.449 299.465 389.129 299.826C388.822 300.175 388.565 300.773 388.385 301.275C388.366 301.326 388.31 301.371 388.224 301.371C388.139 301.371 388.083 301.325 388.064 301.273C387.887 300.772 387.634 300.175 387.326 299.826C387.016 299.476 386.481 299.184 386.033 298.981Z"
        fill="#7C71FC"
        stroke="white"
        strokeWidth="0.335598"
      />
      <path
        d="M384.863 292.804L384.863 292.804C384.515 293.298 384.257 293.894 384.086 294.587C383.915 295.263 383.83 296.013 383.83 296.837V300.493C383.83 302.255 384.167 303.648 384.862 304.651L384.862 304.651L384.864 304.654C385.585 305.653 386.659 306.145 388.056 306.145C389.452 306.145 390.518 305.653 391.223 304.653C391.935 303.649 392.281 302.256 392.281 300.493V296.837C392.281 296.013 392.196 295.263 392.026 294.587C391.855 293.894 391.588 293.298 391.223 292.804C390.874 292.292 390.429 291.894 389.888 291.61C389.359 291.324 388.746 291.184 388.056 291.184C387.349 291.184 386.727 291.324 386.197 291.611C385.673 291.895 385.228 292.293 384.863 292.804ZM382.062 296.684C382.062 294.407 382.599 292.665 383.65 291.436C384.698 290.21 386.159 289.59 388.056 289.59C389.952 289.59 391.413 290.21 392.462 291.436C393.513 292.665 394.049 294.407 394.049 296.684V300.645C394.049 302.992 393.512 304.749 392.463 305.943C391.415 307.136 389.954 307.739 388.056 307.739C386.157 307.739 384.696 307.136 383.648 305.943C382.599 304.749 382.062 302.992 382.062 300.645V296.684Z"
        fill="#7C71FC"
        stroke="white"
        strokeWidth="0.335598"
      />
      <path
        d="M315.951 106.496H335.635L355.32 126.18L355.147 160.887H335.635V126.18L315.951 106.496ZM315.951 106.496H310.598L302.31 109.95L297.993 106.323H292.123L277.791 125.662V161.06M333.736 108.914L351.693 126.18V157.606H339.261V126.18L322.167 108.914H333.736Z"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M277.273 160.714H293.849L328.901 119.619L320.786 111.331L283.834 154.498"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M253.978 94.3559C253.672 94.0143 253.233 93.7314 252.818 93.5119C253.227 93.2896 253.658 93.0034 253.975 92.6547C254.281 92.3183 254.534 91.8273 254.731 91.3634C254.934 91.8271 255.191 92.3169 255.49 92.6512C255.79 92.9859 256.23 93.2733 256.645 93.4996C256.224 93.7221 255.776 94.0095 255.466 94.3559C255.165 94.6912 254.915 95.1685 254.72 95.6222C254.527 95.1689 254.279 94.6918 253.978 94.3559Z"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M275.044 80.1971C274.738 79.8555 274.298 79.5726 273.883 79.353C274.292 79.1307 274.724 78.8446 275.04 78.4959C275.346 78.1595 275.6 77.6685 275.796 77.2046C275.999 77.6683 276.256 78.1581 276.556 78.4924C276.856 78.8271 277.295 79.1145 277.711 79.3408C277.289 79.5632 276.842 79.8507 276.531 80.1971C276.231 80.5324 275.981 81.0097 275.786 81.4634C275.593 81.0101 275.345 80.533 275.044 80.1971Z"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M260.95 78.8336C260.77 78.6325 260.54 78.4627 260.313 78.3234C260.537 78.182 260.763 78.0109 260.947 77.8085C261.127 77.6104 261.279 77.3543 261.404 77.1001C261.532 77.3537 261.684 77.6085 261.86 77.8051C262.037 78.0018 262.265 78.1722 262.493 78.3143C262.26 78.4564 262.025 78.6294 261.842 78.8336C261.667 79.029 261.518 79.2764 261.395 79.5221C261.273 79.2766 261.125 79.0294 260.95 78.8336Z"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M306.468 80.5958H311.648L313.03 81.8045"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M297.835 80.5958H303.36"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M306.468 91.8192H302.842L304.742 87.6752"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M302.038 96.6523C302.038 96.6523 303.193 97.9947 305.028 97.9947C306.862 97.9947 308.079 96.6523 308.079 96.6523"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M295.072 91.6467L299.043 94.2368C299.043 94.2368 299.043 96.8268 299.043 97.8628C299.043 98.8988 300.252 99.4168 304.223 102.698"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M317.347 89.5746L314.239 91.992M314.239 91.992V97.8627C314.239 100.28 313.746 101.823 308.713 104.079C303.706 106.324 300.598 107.705 299.907 108.05M314.239 91.992L311.13 94.2367V98.0354C311.13 98.8987 310.923 99.8311 307.332 101.489C303.74 103.146 301.979 103.964 301.116 104.424C300.252 104.885 297.835 106.151 297.835 106.151"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M295.245 99.5895L301.115 104.252"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M317.173 97.5174C317.173 102.49 315.274 104.252 310.439 106.496L302.324 109.95L295.072 103.906V84.9126V77.1425H311.303L317.173 83.0132V84.9126V87.6753C317.173 88.884 317.173 92.5446 317.173 97.5174ZM317.173 97.5174V102.87C317.116 104.021 317.691 106.496 320.454 106.496C322.626 106.496 325.546 106.496 327.534 106.496M314.929 77.1425L320.454 83.0132V102.87C320.454 105.115 321.801 106.496 325.807 106.496C326.505 106.496 327.074 106.496 327.534 106.496M328.915 106.496C327.246 106.496 323.908 106.185 323.908 102.87C323.908 99.5549 323.908 88.0782 323.908 83.0132L318.382 77.1425M328.915 106.496C328.546 106.496 328.074 106.496 327.534 106.496M328.915 106.496C329.438 106.496 329.709 106.496 327.534 106.496M322.181 77.1425L327.534 83.0132V102.87C327.591 104.079 327.879 106.496 332.714 106.496C333.145 106.496 331.62 106.496 327.534 106.496"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M291.791 76.9697L291.791 102.697C291.791 104.769 287.82 106.324 286.438 106.324C285.057 106.324 291.791 106.324 291.791 106.324C293.172 106.324 295.072 104.908 295.072 102.697"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M291.791 73.1711L286.957 76.9699H330.815L326.67 73.1711M291.791 73.1711H326.67M291.791 73.1711V67.8184L319.418 48.9974C320.051 49.2852 322.872 50.586 329.088 53.4868C335.304 56.3877 335.937 61.9476 335.477 64.365L326.67 59.7029L321.318 67.8184L326.67 73.1711"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M298.18 84.7399C298.18 83.4048 299.339 82.3225 300.77 82.3225C302.2 82.3225 303.36 83.4048 303.36 84.7399"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M306.814 84.7399C306.814 83.4048 307.973 82.3225 309.404 82.3225C310.834 82.3225 311.994 83.4048 311.994 84.7399"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M264.841 160.887V108.525V98.7261L266.74 98.7261L268.64 98.7261V160.887H264.841Z"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M259.661 88.0207L266.74 80.7686M259.661 88.0207L262.941 98.5535M259.661 88.0207L263.805 91.1287M266.74 88.7113L263.805 91.1287M266.74 88.7113L269.675 91.1287M266.74 88.7113V80.7686M263.805 91.1287L265.531 95.9635M265.531 95.9635H266.74M265.531 95.9635L262.941 98.5535M267.949 95.9635L269.675 91.1287M267.949 95.9635H266.74M267.949 95.9635L270.366 98.5535M269.675 91.1287L273.82 88.0207M266.74 80.7686L273.82 88.0207M273.82 88.0207L270.366 98.5535M270.366 98.5535H266.74M266.74 98.5535H262.941M266.74 98.5535V95.9635"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M268.812 106.842L274.337 104.597L275.201 99.0714C274.971 99.5894 274.234 100.833 273.129 101.661C272.024 102.49 269.79 103.388 268.812 103.733"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M264.668 106.842L259.143 104.597L258.279 99.0714C258.509 99.5894 259.246 100.833 260.351 101.661C261.456 102.49 263.69 103.388 264.668 103.733"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M268.64 103.906L266.74 105.633L264.841 103.906"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M268.64 107.014L266.74 108.741L264.841 107.014"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M268.64 103.906L266.74 105.633L264.841 103.906"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M268.64 107.014L266.74 108.741L264.841 107.014"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M268.64 100.798L266.74 102.525L264.841 100.798"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <rect
        x="260.006"
        y="127.734"
        width="14.8496"
        height="13.1229"
        fill="white"
      />
      <path
        d="M265.532 133.26H261.133C259.661 133.26 259.661 136.023 261.133 136.023M274.683 129.461L272.439 127.389H262.769C262.769 128.368 263.091 130.325 264.377 130.325H269.042C269.042 132.569 270.373 133.26 271.403 133.26M274.683 129.461V138.785M274.683 129.461C274.683 129.058 275.547 128.425 276.237 128.425C276.928 128.425 277.791 129.116 277.791 129.461V138.785C277.791 139.131 276.928 139.821 276.237 139.821C275.547 139.821 274.683 139.131 274.683 138.785M264.841 130.325H261.042C259.661 130.325 259.661 133.26 261.042 133.26M274.683 138.785L272.417 141.203H260.048C260.048 140.339 260.01 138.785 261.38 138.785H265.532M265.532 136.023H261.087C259.518 136.023 259.78 138.785 261.087 138.785"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M318.713 119.101V123.245"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M316.642 121.173H320.786"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M307.663 132.224V136.368"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M305.591 134.296H309.735"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M295.576 145.692V149.836"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M293.504 147.764H297.648"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <circle
        cx="313.016"
        cy="127.562"
        r="1.5735"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <circle
        cx="301.619"
        cy="141.721"
        r="1.5735"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <circle
        cx="289.532"
        cy="155.189"
        r="1.5735"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M277.944 131.168H280.573V137.078H277.944V131.168Z"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M280.726 160.542V125.835L294.885 106.323"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M283.834 160.542V125.835L297.993 106.323"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <circle
        cx="302.828"
        cy="112.194"
        r="2.09151"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M300.583 111.849H293.849"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M305.059 111.754L316.642 107.187"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M304.728 111.849H320.268"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M300.411 111.504L296.267 109.086"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M327.52 118.065L290.741 160.887"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M299.202 154.326H320.268M292.468 160.714L335.635 160.887V154.326H333.736"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M291.95 144.908C291.95 137.699 289 130.326 283.834 126.081"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M294.54 142.317C294.54 135.108 290.727 127.908 285.561 123.663"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M335.635 127.118C331.628 130.411 328.954 135.587 327.956 141.108"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M333.909 124.699C329.28 128.503 325.738 134.679 325.051 141.108"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M348.606 150.141C348.565 150.015 348.457 149.924 348.327 149.905L346.525 149.645L345.719 148.021C345.602 147.785 345.217 147.785 345.1 148.021L344.295 149.645L342.493 149.905C342.362 149.924 342.254 150.015 342.214 150.141C342.173 150.266 342.207 150.403 342.302 150.495L343.605 151.759L343.297 153.543C343.275 153.672 343.328 153.803 343.434 153.88C343.54 153.958 343.682 153.968 343.798 153.907L345.41 153.064L347.022 153.907C347.072 153.934 347.127 153.947 347.182 153.947C347.254 153.947 347.325 153.924 347.385 153.88C347.492 153.803 347.545 153.672 347.522 153.543L347.215 151.759L348.518 150.495C348.612 150.403 348.646 150.266 348.606 150.141ZM346.603 151.39C346.521 151.469 346.484 151.584 346.503 151.696L346.723 152.971L345.57 152.368C345.52 152.342 345.465 152.329 345.41 152.329C345.355 152.329 345.3 152.342 345.25 152.368L344.096 152.971L344.316 151.696C344.336 151.584 344.298 151.469 344.216 151.39L343.287 150.488L344.573 150.302C344.685 150.286 344.782 150.216 344.833 150.114L345.41 148.951L345.986 150.114C346.037 150.216 346.134 150.286 346.246 150.302L347.532 150.488L346.603 151.39Z"
        fill="#7C71FC"
        stroke="#7C71FC"
        strokeWidth="0.503397"
      />
      <path
        d="M329.957 153.595C329.917 153.47 329.809 153.379 329.678 153.36L327.876 153.099L327.071 151.475C326.954 151.24 326.569 151.24 326.452 151.475L325.646 153.099L323.844 153.36C323.714 153.379 323.606 153.47 323.565 153.595C323.525 153.72 323.559 153.858 323.653 153.949L324.956 155.213L324.649 156.997C324.626 157.127 324.679 157.257 324.786 157.335C324.892 157.412 325.033 157.422 325.149 157.362L326.761 156.518L328.373 157.362C328.424 157.388 328.479 157.401 328.533 157.401C328.605 157.401 328.677 157.379 328.737 157.335C328.843 157.257 328.896 157.127 328.874 156.997L328.566 155.213L329.869 153.949C329.964 153.858 329.998 153.72 329.957 153.595ZM327.955 154.844C327.873 154.924 327.835 155.038 327.855 155.151L328.075 156.426L326.921 155.822C326.871 155.796 326.816 155.783 326.761 155.783C326.706 155.783 326.651 155.796 326.601 155.822L325.448 156.426L325.668 155.151C325.687 155.038 325.65 154.924 325.568 154.844L324.639 153.943L325.925 153.757C326.037 153.741 326.134 153.67 326.185 153.568L326.761 152.406L327.338 153.568C327.389 153.67 327.486 153.741 327.598 153.757L328.884 153.943L327.955 154.844Z"
        fill="#7C71FC"
        stroke="#7C71FC"
        strokeWidth="0.503397"
      />
      <path
        d="M348.606 139.432C348.565 139.307 348.457 139.215 348.327 139.196L346.525 138.936L345.719 137.312C345.602 137.077 345.217 137.077 345.1 137.312L344.295 138.936L342.493 139.196C342.362 139.215 342.254 139.307 342.214 139.432C342.173 139.557 342.207 139.695 342.302 139.786L343.605 141.05L343.297 142.834C343.275 142.963 343.328 143.094 343.434 143.172C343.54 143.249 343.682 143.259 343.798 143.199L345.41 142.355L347.022 143.199C347.072 143.225 347.127 143.238 347.182 143.238C347.254 143.238 347.325 143.216 347.385 143.172C347.492 143.094 347.545 142.963 347.522 142.834L347.215 141.05L348.518 139.786C348.612 139.695 348.646 139.557 348.606 139.432ZM346.603 140.681C346.521 140.76 346.484 140.875 346.503 140.988L346.723 142.263L345.57 141.659C345.52 141.633 345.465 141.62 345.41 141.62C345.355 141.62 345.3 141.633 345.25 141.659L344.096 142.263L344.316 140.988C344.336 140.875 344.298 140.76 344.216 140.681L343.287 139.78L344.573 139.594C344.685 139.577 344.782 139.507 344.833 139.405L345.41 138.243L345.986 139.405C346.037 139.507 346.134 139.577 346.246 139.594L347.532 139.78L346.603 140.681Z"
        fill="#7C71FC"
        stroke="#7C71FC"
        strokeWidth="0.503397"
      />
      <path
        d="M348.606 128.723C348.565 128.598 348.457 128.507 348.327 128.488L346.525 128.227L345.719 126.603C345.602 126.368 345.217 126.368 345.1 126.603L344.295 128.227L342.493 128.488C342.362 128.507 342.254 128.598 342.214 128.723C342.173 128.849 342.207 128.986 342.302 129.078L343.605 130.341L343.297 132.125C343.275 132.255 343.328 132.386 343.434 132.463C343.54 132.54 343.682 132.551 343.798 132.49L345.41 131.647L347.022 132.49C347.072 132.516 347.127 132.529 347.182 132.529C347.254 132.529 347.325 132.507 347.385 132.463C347.492 132.386 347.545 132.255 347.522 132.125L347.215 130.341L348.518 129.078C348.612 128.986 348.646 128.849 348.606 128.723ZM346.603 129.972C346.521 130.052 346.484 130.166 346.503 130.279L346.723 131.554L345.57 130.951C345.52 130.924 345.465 130.911 345.41 130.911C345.355 130.911 345.3 130.924 345.25 130.951L344.096 131.554L344.316 130.279C344.336 130.166 344.298 130.052 344.216 129.972L343.287 129.071L344.573 128.885C344.685 128.869 344.782 128.798 344.833 128.697L345.41 127.534L345.986 128.697C346.037 128.798 346.134 128.869 346.246 128.885L347.532 129.071L346.603 129.972Z"
        fill="#7C71FC"
        stroke="#7C71FC"
        strokeWidth="0.503397"
      />
      <path
        d="M331.78 159.348C333.183 157.47 333.762 155.531 333.503 153.585C333.287 151.97 332.469 150.335 331.136 148.857C330.518 148.17 329.929 147.67 329.561 147.382C329.818 147.176 329.988 146.82 329.988 146.415C329.988 146.009 329.816 145.653 329.558 145.448C330.029 144.941 330.917 143.746 330.917 141.934C330.917 141.796 330.826 141.684 330.714 141.684H328.99C328.993 141.506 328.989 141.329 328.969 141.151C328.955 141.027 328.869 140.935 328.768 140.935H324.544C324.443 140.935 324.358 141.027 324.344 141.151C324.324 141.329 324.32 141.506 324.322 141.684H322.598C322.486 141.684 322.395 141.796 322.395 141.934C322.395 143.746 323.283 144.941 323.754 145.448C323.496 145.653 323.324 146.009 323.324 146.415C323.324 146.82 323.495 147.176 323.751 147.382C323.384 147.67 322.795 148.17 322.176 148.857C320.844 150.335 320.026 151.97 319.81 153.585C319.55 155.531 320.13 157.47 321.533 159.348C322.171 160.204 322.861 160.971 324.272 160.971H329.04C330.451 160.971 331.141 160.204 331.78 159.348ZM328.956 142.185H330.505C330.409 143.977 329.314 145.065 329.092 145.267C329.08 145.267 329.068 145.263 329.055 145.263H327.81C328.178 144.658 328.801 143.471 328.956 142.185ZM324.728 141.436H328.585C328.666 143.106 327.556 144.869 327.293 145.263H326.02C325.756 144.869 324.646 143.106 324.728 141.436ZM322.807 142.185H324.357C324.511 143.471 325.135 144.658 325.503 145.263H324.257C324.245 145.263 324.233 145.267 324.22 145.267C323.999 145.066 322.903 143.984 322.807 142.185ZM323.73 146.415C323.73 146.056 323.966 145.763 324.257 145.763H329.055C329.346 145.763 329.583 146.056 329.583 146.415C329.583 146.775 329.346 147.067 329.055 147.067H324.257C323.966 147.067 323.73 146.775 323.73 146.415ZM321.83 159.009C320.517 157.25 319.972 155.453 320.21 153.669C320.667 150.241 323.875 147.86 324.285 147.568H329.027C329.438 147.86 332.646 150.241 333.103 153.669C333.341 155.453 332.795 157.25 331.482 159.009C330.885 159.808 330.289 160.47 329.04 160.47H324.272C323.024 160.47 322.428 159.808 321.83 159.009Z"
        stroke="#7C71FC"
        strokeWidth="0.838996"
      />
      <path
        d="M316.987 215.105H297.303L277.618 195.421L277.791 160.714H297.303V195.421L316.987 215.105ZM316.987 215.105H322.34L330.628 211.652L334.945 215.278H340.815L355.147 195.939V160.542M299.202 212.688L281.245 195.421V163.995H293.677V195.421L310.771 212.688H299.202Z"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M355.665 160.887H339.089L304.037 201.982L312.152 210.27L349.104 167.103"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M378.96 227.245C379.266 227.587 379.705 227.87 380.12 228.089C379.711 228.312 379.28 228.598 378.963 228.947C378.657 229.283 378.404 229.774 378.207 230.238C378.004 229.774 377.747 229.284 377.448 228.95C377.148 228.615 376.708 228.328 376.293 228.102C376.714 227.879 377.162 227.592 377.472 227.245C377.773 226.91 378.023 226.433 378.218 225.979C378.411 226.432 378.659 226.909 378.96 227.245Z"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M357.894 241.404C358.2 241.746 358.64 242.029 359.054 242.248C358.646 242.471 358.214 242.757 357.898 243.105C357.592 243.442 357.338 243.933 357.142 244.397C356.939 243.933 356.682 243.443 356.382 243.109C356.082 242.774 355.643 242.487 355.227 242.26C355.649 242.038 356.096 241.751 356.407 241.404C356.707 241.069 356.957 240.592 357.152 240.138C357.345 240.591 357.593 241.068 357.894 241.404Z"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M371.988 242.768C372.168 242.969 372.398 243.139 372.625 243.278C372.401 243.419 372.175 243.59 371.991 243.793C371.811 243.991 371.659 244.247 371.534 244.501C371.406 244.248 371.254 243.993 371.078 243.796C370.901 243.6 370.673 243.429 370.445 243.287C370.678 243.145 370.913 242.972 371.096 242.768C371.271 242.572 371.42 242.325 371.543 242.079C371.665 242.325 371.813 242.572 371.988 242.768Z"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M326.47 241.006H321.29L319.908 239.797"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M335.103 241.006H329.578"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M326.47 229.782H330.096L328.196 233.926"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M330.614 224.429H325.088"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M337.866 229.955L333.895 227.365C333.895 227.365 333.895 224.775 333.895 223.739C333.895 222.703 332.686 222.185 328.715 218.904"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M315.591 232.027L318.699 229.609M318.699 229.609V223.739C318.699 221.321 319.192 219.778 324.225 217.523C329.232 215.278 332.34 213.896 333.031 213.551M318.699 229.609L321.807 227.365V223.566C321.807 222.703 322.015 221.77 325.606 220.113C329.198 218.455 330.959 217.638 331.822 217.177C332.686 216.717 335.103 215.45 335.103 215.45"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M337.693 222.012L331.823 217.35"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M315.765 224.084C315.765 219.111 317.664 217.35 322.499 215.105L330.614 211.652L337.866 217.695V236.689V244.459H321.635L315.765 238.588V236.689V233.926C315.765 232.717 315.765 229.057 315.765 224.084ZM315.765 224.084V218.731C315.822 217.58 315.247 215.105 312.484 215.105C310.312 215.105 307.392 215.105 305.404 215.105M318.009 244.459L312.484 238.588V218.731C312.484 216.486 311.137 215.105 307.131 215.105C306.433 215.105 305.864 215.105 305.404 215.105M304.023 215.105C305.692 215.105 309.03 215.416 309.03 218.731C309.03 222.046 309.03 233.523 309.03 238.588L314.556 244.459M304.023 215.105C304.392 215.105 304.864 215.105 305.404 215.105M304.023 215.105C303.5 215.105 303.229 215.105 305.404 215.105M310.757 244.459L305.404 238.588V218.731C305.347 217.522 305.059 215.105 300.224 215.105C299.793 215.105 301.318 215.105 305.404 215.105"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M341.147 244.632L341.147 218.904C341.147 216.832 345.118 215.278 346.499 215.278C347.881 215.278 341.147 215.278 341.147 215.278C339.765 215.278 337.866 216.694 337.866 218.904"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M341.147 248.43L345.981 244.632H302.123L306.268 248.43M341.147 248.43H306.268M341.147 248.43V253.783L313.52 272.604C312.886 272.316 310.066 271.015 303.85 268.115C297.634 265.214 297.001 259.654 297.461 257.236L306.268 261.899L311.62 253.783L306.268 248.43"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <circle
        cx="332.168"
        cy="238.071"
        r="1.20828"
        transform="rotate(-180 332.168 238.071)"
        fill="#7C71FC"
      />
      <path
        d="M334.758 236.862C334.758 238.197 333.598 239.279 332.168 239.279C330.737 239.279 329.578 238.197 329.578 236.862"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M326.124 236.862C326.124 238.197 324.965 239.279 323.534 239.279C322.104 239.279 320.944 238.197 320.944 236.862"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <circle
        cx="323.535"
        cy="238.071"
        r="1.20828"
        transform="rotate(-180 323.535 238.071)"
        fill="#7C71FC"
      />
      <path
        d="M368.097 160.714V213.077V222.875L366.198 222.875L364.298 222.875V160.714H368.097Z"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M373.277 233.581L366.198 240.833M373.277 233.581L369.997 223.048M373.277 233.581L369.133 230.473M366.198 232.89L369.133 230.473M366.198 232.89L363.263 230.473M366.198 232.89V240.833M369.133 230.473L367.407 225.638M367.407 225.638H366.198M367.407 225.638L369.997 223.048M364.989 225.638L363.263 230.473M364.989 225.638H366.198M364.989 225.638L362.572 223.048M363.263 230.473L359.118 233.581M366.198 240.833L359.118 233.581M359.118 233.581L362.572 223.048M362.572 223.048H366.198M366.198 223.048H369.997M366.198 223.048V225.638"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M364.125 214.76L358.6 217.005L357.737 222.53C357.967 222.012 358.704 220.769 359.809 219.94C360.914 219.111 363.147 218.213 364.125 217.868"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M368.27 214.76L373.795 217.005L374.658 222.53C374.428 222.012 373.691 220.769 372.586 219.94C371.481 219.111 369.248 218.213 368.27 217.868"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M364.298 217.695L366.198 215.969L368.097 217.695"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M364.298 214.587L366.198 212.86L368.097 214.587"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M364.298 217.695L366.198 215.969L368.097 217.695"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M364.298 214.587L366.198 212.86L368.097 214.587"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M364.298 220.803L366.198 219.077L368.097 220.803"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <rect
        x="372.932"
        y="193.867"
        width="14.8496"
        height="13.1229"
        transform="rotate(-180 372.932 193.867)"
        fill="white"
      />
      <path
        d="M367.406 188.341H371.805C373.277 188.341 373.277 185.579 371.805 185.579M358.255 192.14L360.499 194.212H370.169C370.169 193.234 369.847 191.277 368.561 191.277H363.896C363.896 189.032 362.565 188.341 361.535 188.341M358.255 192.14V182.816M358.255 192.14C358.255 192.543 357.391 193.176 356.701 193.176C356.01 193.176 355.147 192.485 355.147 192.14V182.816C355.147 182.471 356.01 181.78 356.701 181.78C357.391 181.78 358.255 182.471 358.255 182.816M368.097 191.277H371.896C373.277 191.277 373.277 188.341 371.896 188.341M358.255 182.816L360.521 180.399H372.89C372.89 181.262 372.928 182.816 371.558 182.816H367.406M367.406 185.579H371.851C373.42 185.579 373.158 182.816 371.851 182.816"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path d="M314.225 202.5V198.356" stroke="#7C71FC" strokeWidth="1.34239" />
      <path
        d="M316.296 200.428H312.152"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M325.275 189.377V185.233"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M327.347 187.305H323.203"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M337.362 175.909V171.765"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M339.434 173.837H335.29"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <circle
        cx="319.922"
        cy="194.039"
        r="1.5735"
        transform="rotate(-180 319.922 194.039)"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <circle
        cx="331.319"
        cy="179.881"
        r="1.5735"
        transform="rotate(-180 331.319 179.881)"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <circle
        cx="343.406"
        cy="166.412"
        r="1.5735"
        transform="rotate(-180 343.406 166.412)"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M354.994 190.433H352.365V184.523H354.994V190.433Z"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M352.212 161.06V195.766L338.053 215.278"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M349.104 161.06V195.766L334.945 215.278"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <circle
        cx="330.11"
        cy="209.407"
        r="2.09151"
        transform="rotate(-180 330.11 209.407)"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M332.355 209.752H339.089"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M327.879 209.749L316.296 214.415"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path d="M328.21 209.752H312.67" stroke="#7C71FC" strokeWidth="1.34239" />
      <path
        d="M332.527 210.098L336.671 212.515"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M305.418 203.536L342.197 160.714"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M333.736 167.276H312.67M340.47 160.887L297.303 160.714V167.276H299.202"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M340.988 176.861C340.988 184.071 343.938 191.443 349.104 195.688"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M338.398 179.452C338.398 186.661 342.211 193.861 347.376 198.106"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M297.303 194.652C301.31 191.359 303.984 186.183 304.982 180.661"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M299.029 197.07C303.658 193.266 307.2 187.09 307.887 180.661"
        stroke="#7C71FC"
        strokeWidth="1.34239"
      />
      <path
        d="M284.332 171.629C284.373 171.754 284.481 171.845 284.611 171.864L286.413 172.125L287.219 173.749C287.336 173.984 287.721 173.984 287.838 173.749L288.643 172.125L290.445 171.864C290.576 171.845 290.684 171.754 290.724 171.629C290.765 171.503 290.731 171.366 290.636 171.274L289.333 170.011L289.641 168.227C289.663 168.097 289.61 167.966 289.504 167.889C289.398 167.812 289.256 167.801 289.14 167.862L287.528 168.705L285.916 167.862C285.866 167.836 285.811 167.823 285.756 167.823C285.684 167.823 285.613 167.845 285.553 167.889C285.446 167.966 285.393 168.097 285.416 168.227L285.723 170.011L284.42 171.274C284.326 171.366 284.292 171.503 284.332 171.629ZM286.335 170.38C286.417 170.3 286.454 170.186 286.435 170.073L286.215 168.798L287.368 169.401C287.418 169.428 287.473 169.441 287.528 169.441C287.583 169.441 287.638 169.428 287.688 169.401L288.842 168.798L288.622 170.073C288.602 170.186 288.64 170.3 288.722 170.38L289.651 171.281L288.365 171.467C288.253 171.483 288.156 171.554 288.105 171.655L287.528 172.818L286.952 171.655C286.901 171.554 286.804 171.483 286.692 171.467L285.406 171.281L286.335 170.38Z"
        fill="#7C71FC"
        stroke="#7C71FC"
        strokeWidth="0.503397"
      />
      <path
        d="M302.981 168.174C303.021 168.3 303.129 168.391 303.26 168.41L305.062 168.67L305.867 170.294C305.984 170.529 306.369 170.529 306.486 170.294L307.292 168.67L309.094 168.41C309.224 168.391 309.332 168.3 309.373 168.174C309.413 168.049 309.379 167.912 309.285 167.82L307.982 166.556L308.289 164.772C308.312 164.643 308.259 164.512 308.152 164.435C308.046 164.357 307.905 164.347 307.789 164.408L306.177 165.251L304.565 164.408C304.514 164.381 304.459 164.368 304.404 164.368C304.333 164.368 304.261 164.391 304.201 164.435C304.095 164.512 304.042 164.643 304.064 164.772L304.372 166.556L303.069 167.82C302.974 167.912 302.94 168.049 302.981 168.174ZM304.983 166.925C305.065 166.846 305.103 166.731 305.083 166.619L304.863 165.344L306.017 165.947C306.067 165.973 306.122 165.986 306.177 165.986C306.232 165.986 306.287 165.973 306.337 165.947L307.49 165.344L307.27 166.619C307.251 166.731 307.288 166.846 307.37 166.925L308.299 167.827L307.013 168.013C306.901 168.029 306.804 168.099 306.753 168.201L306.177 169.364L305.6 168.201C305.549 168.099 305.452 168.029 305.34 168.013L304.054 167.827L304.983 166.925Z"
        fill="#7C71FC"
        stroke="#7C71FC"
        strokeWidth="0.503397"
      />
      <path
        d="M284.332 182.338C284.373 182.463 284.481 182.554 284.611 182.573L286.413 182.834L287.219 184.458C287.336 184.693 287.721 184.693 287.838 184.458L288.643 182.834L290.445 182.573C290.576 182.554 290.684 182.463 290.724 182.338C290.765 182.212 290.731 182.075 290.636 181.983L289.333 180.719L289.641 178.936C289.663 178.806 289.61 178.675 289.504 178.598C289.398 178.52 289.256 178.51 289.14 178.571L287.528 179.414L285.916 178.571C285.866 178.544 285.811 178.531 285.756 178.531C285.684 178.531 285.613 178.554 285.553 178.598C285.446 178.675 285.393 178.806 285.416 178.936L285.723 180.719L284.42 181.983C284.326 182.075 284.292 182.212 284.332 182.338ZM286.335 181.088C286.417 181.009 286.454 180.894 286.435 180.782L286.215 179.507L287.368 180.11C287.418 180.136 287.473 180.149 287.528 180.149C287.583 180.149 287.638 180.136 287.688 180.11L288.842 179.507L288.622 180.782C288.602 180.894 288.64 181.009 288.722 181.088L289.651 181.99L288.365 182.176C288.253 182.192 288.156 182.262 288.105 182.364L287.528 183.527L286.952 182.364C286.901 182.262 286.804 182.192 286.692 182.176L285.406 181.99L286.335 181.088Z"
        fill="#7C71FC"
        stroke="#7C71FC"
        strokeWidth="0.503397"
      />
      <path
        d="M284.332 193.046C284.373 193.171 284.481 193.263 284.611 193.282L286.413 193.542L287.219 195.166C287.336 195.401 287.721 195.401 287.838 195.166L288.643 193.542L290.445 193.282C290.576 193.263 290.684 193.171 290.724 193.046C290.765 192.921 290.731 192.783 290.636 192.692L289.333 191.428L289.641 189.644C289.663 189.515 289.61 189.384 289.504 189.306C289.398 189.229 289.256 189.219 289.14 189.279L287.528 190.123L285.916 189.279C285.866 189.253 285.811 189.24 285.756 189.24C285.684 189.24 285.613 189.262 285.553 189.306C285.446 189.384 285.393 189.515 285.416 189.644L285.723 191.428L284.42 192.692C284.326 192.783 284.292 192.921 284.332 193.046ZM286.335 191.797C286.417 191.718 286.454 191.603 286.435 191.49L286.215 190.215L287.368 190.819C287.418 190.845 287.473 190.858 287.528 190.858C287.583 190.858 287.638 190.845 287.688 190.819L288.842 190.215L288.622 191.49C288.602 191.603 288.64 191.718 288.722 191.797L289.651 192.698L288.365 192.884C288.253 192.901 288.156 192.971 288.105 193.073L287.528 194.235L286.952 193.073C286.901 192.971 286.804 192.901 286.692 192.884L285.406 192.698L286.335 191.797Z"
        fill="#7C71FC"
        stroke="#7C71FC"
        strokeWidth="0.503397"
      />
      <path
        d="M301.158 162.421C299.755 164.3 299.175 166.239 299.435 168.184C299.651 169.799 300.469 171.434 301.802 172.913C302.42 173.599 303.009 174.1 303.377 174.388C303.12 174.594 302.95 174.949 302.95 175.354C302.95 175.76 303.122 176.116 303.38 176.322C302.909 176.828 302.021 178.023 302.021 179.835C302.021 179.974 302.112 180.086 302.224 180.086H303.948C303.945 180.263 303.949 180.441 303.969 180.618C303.983 180.742 304.069 180.834 304.17 180.834H308.394C308.495 180.834 308.58 180.742 308.594 180.618C308.614 180.441 308.618 180.263 308.616 180.086H310.34C310.452 180.086 310.543 179.974 310.543 179.835C310.543 178.023 309.655 176.828 309.184 176.322C309.442 176.116 309.614 175.76 309.614 175.354C309.614 174.949 309.443 174.594 309.186 174.388C309.554 174.1 310.143 173.599 310.762 172.913C312.094 171.434 312.912 169.799 313.128 168.184C313.388 166.239 312.808 164.3 311.405 162.421C310.767 161.566 310.077 160.798 308.666 160.798H303.898C302.487 160.798 301.797 161.566 301.158 162.421ZM303.982 179.585H302.433C302.529 177.792 303.624 176.704 303.846 176.502C303.858 176.503 303.87 176.507 303.883 176.507H305.128C304.76 177.112 304.137 178.299 303.982 179.585ZM308.21 180.333H304.353C304.272 178.663 305.382 176.901 305.645 176.507H306.918C307.182 176.901 308.292 178.663 308.21 180.333ZM310.131 179.585H308.581C308.427 178.299 307.803 177.112 307.435 176.507H308.681C308.693 176.507 308.705 176.503 308.718 176.502C308.939 176.703 310.035 177.786 310.131 179.585ZM309.208 175.354C309.208 175.714 308.972 176.006 308.681 176.006H303.883C303.592 176.006 303.355 175.714 303.355 175.354C303.355 174.995 303.592 174.702 303.883 174.702H308.681C308.972 174.702 309.208 174.995 309.208 175.354ZM311.107 162.761C312.421 164.519 312.966 166.316 312.728 168.101C312.271 171.529 309.063 173.91 308.653 174.201H303.911C303.5 173.91 300.292 171.529 299.835 168.101C299.597 166.316 300.143 164.519 301.456 162.761C302.053 161.961 302.649 161.299 303.898 161.299H308.666C309.914 161.299 310.51 161.961 311.107 162.761Z"
        stroke="#7C71FC"
        strokeWidth="0.838996"
      />
      <defs>
        <filter
          id="filter0_f"
          x="241.429"
          y="325.947"
          width="62.798"
          height="43.7448"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2.01359"
            result="effect1_foregroundBlur"
          />
        </filter>
      </defs>
    </svg>
  );
};
